import { render } from "./MessageTyping.vue?vue&type=template&id=52cd4308&scoped=true"
import script from "./MessageTyping.vue?vue&type=script&lang=js"
export * from "./MessageTyping.vue?vue&type=script&lang=js"

import "./MessageTyping.vue?vue&type=style&index=0&id=52cd4308&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cd4308"]])

export default __exports__